import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'

export const Tooltip = ({
  id,
  content,
  placement = 'bottom-start',
  offset = 0,
  disabled = false,
  dataTestId = 'tooltip',
  portal = false,
  children,
}) => {
  const toolTipId = id || content || 'tooltip'

  const tooltipElement = !disabled && (
    <ReactTooltip id={toolTipId} opacity={1} place={placement} offset={offset} noArrow />
  )

  return (
    <div>
      <span
        data-tooltip-id={toolTipId}
        data-tooltip-content={content}
        data-testid={`tooltip-${dataTestId}`}
      >
        {children}
      </span>

      {!disabled && (portal ? createPortal(tooltipElement, document.body) : tooltipElement)}
    </div>
  )
}

Tooltip.propTypes = {
  id: PropTypes.string,
  content: PropTypes.string,
  placement: PropTypes.string,
  offset: PropTypes.number,
  disabled: PropTypes.bool,
  dataTestId: PropTypes.string,
  portal: PropTypes.bool,
  children: PropTypes.node.isRequired,
}
